import { use } from 'react';
import { RootElementContext } from '@/providers/root-element/root-element-context';

export const useRootElement = () => use(RootElementContext);
